import SiteNav from "./components/SiteNav";
import Hero from "./components/Hero";
import QuickScan from "./components/QuickScan";
import PenaltyFlow from "./components/PenaltyFlow";
import TakedownList from "./components/TakedownList";
import RegulationDebate from "./components/RegulationDebate";
import Voices from "./components/Voices";
import Timeline from "./components/Timeline";
import HotComments from "./components/HotComments";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div id="top" className="min-h-screen w-full bg-background-50 text-foreground-900">
      <SiteNav />
      <main className="w-full">
        <Hero />
        <QuickScan />
        <PenaltyFlow />
        <TakedownList />
        <RegulationDebate />
        <Voices />
        <Timeline />
        <HotComments />
      </main>
      <Footer />
    </div>
  );
}